import React from 'react'
import { Alert } from 'react-bootstrap'
import { memo } from 'react'
const PPCAlerts = ({ campaign, inventoryCampaign, auctionType, language, DRAFT_STATUS, ppc_modal_alert_messages, is_content_auction, changeTab }) => {
    const msgs = ppc_modal_alert_messages[language]
    const alerts = []

    const isDraftStatus = inventoryCampaign?.inventory_campaign_status === DRAFT_STATUS
    const isPpcActive = campaign?.ppc_active
    const isPpcPaused = campaign?.ppc_paused
    const isNotIntervalAuction = auctionType !== 'interval'
    const isPpcBidActive = inventoryCampaign?.ppc_bid_active

    if (!is_content_auction && !isPpcActive) {
        alerts.push({ variant: 'danger', message: msgs.preview_inactive })
    }

    if (isPpcActive && isPpcPaused && isNotIntervalAuction) {
        alerts.push({ variant: 'warning', message: msgs.preview_paused })
    }

    if (isDraftStatus) {
        if (!is_content_auction) {
            if (!isPpcBidActive) {
                alerts.push({ variant: 'warning', message: msgs.activate })
            } else {
                alerts.push({ variant: 'warning', message: msgs.submit })
            }
        } else {
            alerts.push({ variant: 'warning', message: msgs.customize_and_activate, change_tab: true })
        }
    }

    return alerts.map(({ variant, message, change_tab = false }, idx) => {
        // Handle both object { strong, rest } and string message formats
        const isMessageObject = message && typeof message === 'object';
        const strongText = isMessageObject ? (message.strong || '') : '';
        const restText = isMessageObject ? (message.rest || '') : (message || '');

        return (
            <Alert key={idx} variant={variant} className="mt-3 mb-0" {...(change_tab && { onClick: () => changeTab(), style: { cursor: 'pointer' } })}>
                {strongText && <strong>{strongText}</strong>} {restText}
            </Alert>
        );
    })
}

export default memo(PPCAlerts)
